export default __webpack_public_path__ + "static/media/arrowLeft.f80510be.svg";